import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'enrolments/v4';

  pathForType(...args: Parameters<ApplicationAdapter['pathForType']>) {
    return super
      .pathForType(...args)
      .replace('enrolments/', '')
      .toLowerCase();
  }
}
